document.addEventListener("DOMContentLoaded", async () => {

  if (!window.currentProduct) return;

  const STORAGE_KEY = "vrindaa_recently_viewed";

  /* -----------------------------
     Save Current Product
  ------------------------------ */

  let viewed = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

  viewed = viewed.filter(item => item.id !== window.currentProduct.id);

  viewed.unshift(window.currentProduct);

  viewed = viewed.slice(0, 8);

  localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));

  /* -----------------------------
     Container
  ------------------------------ */

  const container = document.getElementById("recently-viewed-products");

  if (!container) return;

  container.innerHTML = "<p>Loading...</p>";

  /* -----------------------------
     Fetch Products
  ------------------------------ */

  const products = await Promise.all(

    viewed.map(async (item) => {

      try {
        const response = await fetch(`/products/${item.handle}.js`);
        return await response.json();
      } catch (error) {
        console.error(error);
        return null;
      }

    })

  );

  let html = "";

  products
    .filter(product => product)
    .slice(0, 4)
    .forEach(product => {

      const variant = product.variants[0];

      const price = variant.price;

      const compare = variant.compare_at_price;

      html += `
        <div class="rv-card">

          <a href="${product.url}">

            <img
              class="rv-image first-image"
              src="${product.images[0]}"
              alt="${product.title}"
              loading="lazy"
            >

            ${
              product.images.length > 1
                ? `
                <img
                  class="rv-image second-image"
                  src="${product.images[1]}"
                  alt="${product.title}"
                  loading="lazy"
                >
                `
                : ""
            }

            <h4>${product.title}</h4>

            <p class="rv-price">

              ${
                compare && compare > price
                  ? `
                  <span class="rv-compare-price">
                    ₹ ${Number(compare / 100).toLocaleString("en-IN")}
                  </span>
                  `
                  : ""
              }

              <span class="rv-sale-price">
                ₹ ${Number(price / 100).toLocaleString("en-IN")}
              </span>

            </p>

          </a>

        </div>
      `;

    });

  container.innerHTML = html;

});